export default "__VITE_ASSET__7cab06d5__"